import * as React from 'react'
import { cn } from '../../lib/utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-[6px] border border-[rgba(255,255,255,0.07)] bg-[#0F0F0F]',
        'px-3 py-2 text-sm text-[#F5F5F5] placeholder:text-[#4B5563]',
        'outline-none transition-all duration-150',
        'focus:border-[rgba(46,204,113,0.4)] focus:ring-2 focus:ring-[rgba(46,204,113,0.07)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
)
Input.displayName = 'Input'

export { Input }
